import ActionTypes from "../constants/ActionTypes";

const initialState = {
  isFetching: false,
  sessionId: null,
  errorMessage: null,
  authority_class: null,
  admin_name: null,
  otpAttemptCount: 0,
  errorCode: null,
  accessToken: null,
  refreshToken: null,
  otp_enable: null,
  user_info: null,
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    //ACCESS TOKEN 
    case ActionTypes.ACCESS_TOKEN_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
        otpAttemptCount: 0,
      };
    case ActionTypes.ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        sessionId: action.payload.session_id || null,
        accessToken: action.payload.access_token || state.accessToken,
        refreshToken: action.payload.refresh_token || state.refreshToken,
        authority_class: action.payload.authority_class,
        admin_name: action.payload.admin_name,
        otp_enable: action.payload.otp_enable,
        errorMessage: null,
      };
    case ActionTypes.ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        isFetching: false,
        sessionId: null,
        errorMessage: action.payload,
      };
    //VERIFY OTP
    case ActionTypes.VERIFY_OTP_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      };
    case ActionTypes.VERIFY_OTP_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        otpAttemptCount: 0,
        accessToken: action.payload.access_token,
        refreshToken: action.payload.refresh_token,
        authority_class: action.payload.authority_class,
        admin_name: action.payload.admin_name,
        sessionId: null,
      };
    case ActionTypes.VERIFY_OTP_FAILURE: {
      const payload = action.payload || {};
      const errorType = payload.error_type;

      const isWrongOtp = errorType === "OTP_FORMAT_ERR_MSG";
      const isOtp3Times = errorType === "OTP_VERIFY_FAILED_3TIMES_MSG";

      let nextCount = state.otpAttemptCount;

      if (isWrongOtp) {
        nextCount = state.otpAttemptCount + 1;
      } else if (isOtp3Times) {
        nextCount = 3;
      }

      return {
        ...state,
        isFetching: false,
        errorMessage: payload.message || payload,
        otpAttemptCount: nextCount,
      };
    }

    //RESEND OTP
    case ActionTypes.RESEND_OTP_REQUEST:
      return { 
        ...state, 
        isFetching: false, 
        errorMessage: null
      };
    case ActionTypes.RESEND_OTP_SUCCESS:
      return {
        ...state,
        sessionId: null,
      };
    case ActionTypes.RESEND_OTP_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      };
    //FETCH USER
    case ActionTypes.FETCH_USER_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      };
    case ActionTypes.FETCH_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        user_info: { ...action.payload },
        errorMessage: null
      };
    case ActionTypes.FETCH_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload,
      };
    // LOGOUT
    case ActionTypes.LOGOUT_REQUEST:
      return {
        ...state,
        isFetching: true
      };

    case ActionTypes.LOGOUT_SUCCESS:
      return {
        ...initialState,
        isFetching: false
      };

    case ActionTypes.LOGOUT_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload
      };
    // REFRESH TOKEN
    case ActionTypes.REFRESH_ACCESS_TOKEN_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case ActionTypes.REFRESH_ACCESS_TOKEN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken || state.refreshToken,
        errorMessage: null,
      };
    case ActionTypes.REFRESH_ACCESS_TOKEN_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.payload
      };

    default:
      return state;
  }
};

export default loginReducer;
